import { AppRouteProps } from "@bsm/component";
import React from "react";
import { UserStudentFamilyCreateContainer } from "./container/UserStudentFamilyCreateContainer";


export const UserStudentFamilyCreateRoute = [
    {
        path: "-1",
        element: <UserStudentFamilyCreateContainer />
    },
] as Array<AppRouteProps>